export const model = {
    id: null,
    name: '',
    owner_branch_id: '',
    code: "",
    created_at: '',
    updated_at: ''
};
